/** @format */

import React from "react";

const experienceContent = [
	{
		year: "Aug 2022 - Present",
		position: " Front-end Developer",
		compnayName: "Jast-Tech Limited",
		details: `Contributed front-end software engineering expertise in the development of products through the software lifecycle; from requirements definition through successful deployment. \n
	Developed server-side systems, including the new NCDC Website where I contributed my front-end skills on both the website and the admin panel as well as the online learning portal for National Curriculum Development Center (NCDC).\n
	Collaborated with other companies and built them new websites for the greater good for example Code Impact.\n
	Introduced methodologies and best practices that enhanced product definition, release processes, and customization of applications to user needs.\n
	Collaborated with other companies, developers, and performance engineers to enhance supportability and identify performance bottlenecks. `,
	},
	{
		year: "Nov 2021 - July 2022",
		position: " Front-end Developer",
		compnayName: "Mihasoft",
		details: `Contributed front-end software engineering expertise in the development of products through the software lifecycle; from requirements definition through successful deployment. 
Excelled in rapid application development and management of technological issues for assigned projects; earning the highest customer satisfaction rating for all software solutions delivered. 
Introduced methodologies and best practices that enhanced product definition, release processes, and customization of applications to user needs. 
Developed and contributed front-end skills in building a Fintech called Mihapay. `,
	},
	{
		year: "June 2021 - August 2021",
		position: "Computer Science Internee",
		compnayName: "Web-Info Net",
		details: `Started my internship training at Web Info-Net at the beginning of June and I learned special skill sets that have helped me in my Career development and in the field. i gained confidence in software development alongside other IT-related fields.`,
	},
];

const Experience = () => {
	return (
		<ul>
			{experienceContent.map((val, i) => (
				<li key={i}>
					<div className="icon">
						<i className="fa fa-briefcase"></i>
					</div>
					<span className="time open-sans-font text-uppercase">{val.year}</span>
					<h5 className="poppins-font text-uppercase">
						{val.position}
						<span className="place open-sans-font">{val.compnayName}</span>
					</h5>
					<p className="open-sans-font">{val.details}</p>
				</li>
			))}
		</ul>
	);
};

export default Experience;
